import { useEffect, useRef } from 'react'
import {
  animateAccountCards,
  animateQuestionMarkPopIn,
} from './accountTypeAnimations'

export const useAccountTypeAnimation = () => {
  const accountListRef = useRef<HTMLDivElement>(null)
  const questionMarkRef = useRef<SVGGElement>(null)

  useEffect(() => {
    const tween = animateAccountCards(accountListRef.current)
    return () => {
      tween?.kill()
    }
  }, [])

  useEffect(() => {
    const tween = animateQuestionMarkPopIn(questionMarkRef.current)
    return () => {
      tween?.kill()
    }
  }, [])

  return { accountListRef, questionMarkRef }
}
